import { Institution } from "byzantine/src/types";
import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";
import useInstitutionSettings from "./hooks/useInstitutionSettings";
import { useUserConfiguration } from "../../hooks/useUserConfiguration";
import { Persona } from "./types";

interface PersonaContextInferface {
  institution: Institution;
  hasChangePermission: boolean;
  hasAddPermission: boolean;
  hasDeletePermission: boolean;
  personas: Persona[];
  setPersonas: Dispatch<SetStateAction<Persona[]>>;
}
const PersonaContext = createContext<PersonaContextInferface>({
  institution: { long_name: "" },
  hasChangePermission: false,
  hasAddPermission: false,
  hasDeletePermission: false,
  personas: [],
  setPersonas: () => null,
});

export const PersonaContextProvider = ({ children }: PropsWithChildren) => {
  const institution = useInstitutionSettings();
  const { permissions, roles } = useUserConfiguration();
  const hasChangePermission = permissions.includes("indigo.change_persona");
  const hasAddPermission = permissions.includes("indigo.add_persona");
  const hasDeletePermission = !!(roles.narmi && (institution.is_demo || institution.is_local));
  const [personas, setPersonas] = useState<Persona[]>([]);

  const value = {
    institution,
    hasChangePermission,
    hasAddPermission,
    hasDeletePermission,
    personas,
    setPersonas,
  };
  return <PersonaContext.Provider value={value}>{children}</PersonaContext.Provider>;
};

const usePersonaContext = () => useContext(PersonaContext);

export default usePersonaContext;
